import { useQuery } from "@tanstack/react-query";

import { DealerQueryKeys, getAuctionsSummary } from "./dealerFunctions";

export const useGetAuctionsSummary = (_isAuthenticated: boolean) => {
  return useQuery({
    queryKey: [DealerQueryKeys.AUCTIONS_SUMMARY],
    queryFn: () => getAuctionsSummary(),
    enabled: false
  });
};
